class WalletAlert {
  constructor({
    code,
    link,
    title,
    productId,
    timeToCheck,
    timeEnd,
    giftPrice,
    minAmountCheck,
    maxAmountCheck,
  }) {
    this.code = code.toString().toLowerCase();
    this.link = link;
    this.title = title;
    this.sub_title = this.getSubTitle();
    this.productId = productId;
    this.timeToCheck = timeToCheck;
    this.timeEnd = timeEnd;
    this.giftPrice = giftPrice;
    this.minAmountCheck = minAmountCheck;
    this.maxAmountCheck = maxAmountCheck;
  }
}
WalletAlert.prototype.getSubTitle = function () {
  let country = Shopify.country.toLowerCase();
  console.log({country_sub:country})
  let pools = {
    vn: "tại đây",
    ph: "Here",
    in: "Here",
    id: "Here",
    th: "Here",
  };
  return pools[country] ?? "here";
};
WalletAlert.prototype.timeBegun = function (value) {
  var now = new Date().getTime();
  var beginTime = new Date(value).getTime();
  return now >= beginTime;
};
WalletAlert.prototype.timeExpired = function (value) {
  var now = new Date().getTime();
  var expired = new Date(value).getTime();
  // var day = Math.floor((expired-now)/(24*3600*1000));
  // return day > 0
  return now <= expired;
};
WalletAlert.prototype.valid = function (
  value,
  productId,
  timeToCheck,
  timeEnd,
  giftPrice,
  minAmountCheck,
  maxAmountCheck
) {
  if (this.validCode(value) == false) return false;

  return this.validCondition(
    productId,
    timeToCheck,
    timeEnd,
    giftPrice,
    minAmountCheck,
    maxAmountCheck
  );
};
WalletAlert.prototype.validCode = function (value) {
  return value.toString().toLowerCase() == this.code;
};
WalletAlert.prototype.validCondition = function (
  productId,
  timeToCheck,
  timeEnd,
  giftPrice,
  minAmountCheck,
  maxAmountCheck
) {
  if (
    this.timeBegun(timeToCheck) == false ||
    this.timeExpired(timeEnd) == false
  )
    return false;
  // console.log({without:this.validWithoutAmount()})
  // if(this.validWithoutAmount()) return true;

  return this.checkAmount(productId, giftPrice, minAmountCheck, maxAmountCheck);
};
WalletAlert.prototype.checkAmount = function (
  productId,
  giftPrice,
  minAmountCheck,
  maxAmountCheck
) {
  var amount = $("#cart-total")[0].dataset.amount;
  if (amount == "") {
    var cartAmountText = $("#cart-total .cart-amount").text(); // Get the text
    amount = Number(cartAmountText.replace(/[^\d]/g, "")); // Remove non-numeric characters and parse to number
  }
  console.log({ isexit: this.existWallet(productId) });
  var condition;
  amount = this.existWallet(productId) ? amount - giftPrice : amount;
  if (maxAmountCheck == "") condition = amount >= minAmountCheck;
  else condition = amount >= minAmountCheck && amount <= maxAmountCheck;
  // console.log({amount,condition})
  return condition;
};
WalletAlert.prototype.existWallet = function (productId) {
  var result = $(`a[href*="cart/change?id=${productId}"]`).length > 0;
  // console.log({exist:result})
  return result;
};
WalletAlert.prototype.addAlert = async function () {
  var msg = `${this.title}&nbsp; <a style="color:blue;text-decoration: underline;" href="${this.link}" target="_blank">${this.sub_title}</a>`;
  if (!this.sub_title) {
    var msg = `${this.title}`;
  }
  $(".discount-note.content--success").find(".notice__text").html(msg);
  $(".discount-note.content--success").removeClass("hide");
  $(".discount-note.success-code-discount").addClass("hide");
};
WalletAlert.prototype.addWallet = async function (productId) {
  console.log("add wallet 1");
  let formData = {
    items: [
      {
        id: productId,
        quantity: 1,
      },
    ],
  };
  var _this = this;
  await fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      // Dispatch the 'cart:refresh' event after the POST request is successful
      let event = new Event("cart:refresh");
      document.dispatchEvent(event);

      setTimeout(function () {
        _this.clickApply();
      }, 2000);
    })
    .catch((error) => {
      // console.error('Error:', error);
    });
};
WalletAlert.prototype.hideQuanity = function (productId) {
  setTimeout(function () {
    var block = $(".hs-sticky-cart").find(`div[data-id=${productId}]`);
    block.find(".hs-qtybutton ").css("visibility", "hidden");
    var input_ = block.find("input");
    input_.css("visibility", "hidden");
    input_.attr("disabled", "disabled");
  }, 500);
};
WalletAlert.prototype.action = async function (productId) {
  if (this.existWallet(productId)) {
    this.clickApply();
    return;
  }

  this.addWallet(productId);
};
WalletAlert.prototype.clickApply = async function () {
  $("#get_id_code").val(this.code);
  this.btn_apply = $("button.apply-discount.event-static");
  this.btn_apply.click();
  setTimeout(() => {
    var not_valid = this.discountNotValid();
    console.log({ not_valid });
    if (not_valid) this.addAlert();
  }, 3000);
};
WalletAlert.prototype.discountNotValid = function () {
  //var msg = $(".hs-add-discount").find(".hs--content--warning").find(".notice__text").html()
  var msg = $(".discount-note")
    .find(".content--warning")
    .find(".notice__text")
    .html();
  var regx = new RegExp(`không hợp lệ với`);
  return regx.test(msg);
};
WalletAlert.prototype.active = function (
  code,
  productId,
  timeToCheck,
  timeEnd,
  giftPrice,
  minAmountCheck,
  maxAmountCheck
) {
  if (!code) return;

  if (this.loop) {
    clearTimeout(this.loop);
  }

  this.loop = setTimeout(() => {
    if (
      this.valid(
        code,
        productId,
        timeToCheck,
        timeEnd,
        giftPrice,
        minAmountCheck,
        maxAmountCheck
      )
    ) {
      this.action(productId);
      return;
    }

    //if (this.existWallet(productId)) this.removeWallet(productId)
  }, 300);
};
WalletAlert.prototype.removeCode = function () {
  $(".hs-tag-code-discount")
    .find(".hs-dscto-tag-button")
    .each(function () {
      this.click();
    });
};
WalletAlert.prototype.removeWallet = function (productId) {
  $(`.hs-product-${productId}`).find(".hs-item-close").find("span").click();
};
WalletAlert.prototype.actionWallet = function (
  productId,
  timeToCheck,
  timeEnd,
  giftPrice,
  minAmountCheck,
  maxAmountCheck
) {
  if (
    this.existWallet(productId) &&
    this.validCondition(
      productId,
      timeToCheck,
      timeEnd,
      giftPrice,
      minAmountCheck,
      maxAmountCheck
    ) == false
  ) {
    //this.removeWallet(productId)
    return;
  }
};
WalletAlert.prototype.addeventlistener = function (
  productId,
  timeToCheck,
  timeEnd,
  giftPrice,
  minAmountCheck,
  maxAmountCheck
) {
  var _this = this;
  var loaded = $(".hs-item-cart-content").length > 0;

  if (!loaded) {
    console.log("can't load 2");
    setTimeout(function () {
      _this.addeventlistener();
    }, 1500);
    return false;
  }

  $(".hs-sticky-cart")
    .on("click", ".hs-qtybutton", function () {
      setTimeout(function () {
        _this.actionWallet(
          productId,
          timeToCheck,
          timeEnd,
          giftPrice,
          minAmountCheck,
          maxAmountCheck
        );
      }, 1000);
    })
    .on("click", ".hs-item-close span", function () {
      // console.log("clicked close")
      setTimeout(function () {
        _this.actionWallet(
          productId,
          timeToCheck,
          timeEnd,
          giftPrice,
          minAmountCheck,
          maxAmountCheck
        );
      }, 1500);
    })
    .on("change", "input", function () {
      // console.log("change input")
      setTimeout(function () {
        _this.actionWallet(
          productId,
          timeToCheck,
          timeEnd,
          giftPrice,
          minAmountCheck,
          maxAmountCheck
        );
      }, 1500);
    });

  $("button[type=submit]").on("click", function () {
    // console.log("clicked add to cart")
    setTimeout(function () {
      _this.actionWallet(
        productId,
        timeToCheck,
        timeEnd,
        giftPrice,
        minAmountCheck,
        maxAmountCheck
      );
    }, 1500);
  });

  $("#btn-cart-icon").on("touchstart", function () {
    // console.log("clicked #btn-cart")
    setTimeout(function () {
      _this.actionWallet(
        productId,
        timeToCheck,
        timeEnd,
        giftPrice,
        minAmountCheck,
        maxAmountCheck
      );
    }, 1500);
  });

  $(".hs-container-dynamic-stacked").on(
    "click",
    ".hs-upsell-add-to-cart",
    function () {
      // console.log("hs-upsell-add-to-cart")
      setTimeout(function () {
        _this.actionWallet(
          productId,
          timeToCheck,
          timeEnd,
          giftPrice,
          minAmountCheck,
          maxAmountCheck
        );
      }, 2000);
    }
  );
};
$(document).ready(function () {
  function applyCamp(camp, code) {
    const currentTime = new Date();
    const startTime = new Date(camp.timeToCheck);
    const endTime = new Date(camp.timeEnd);

    if (currentTime >= startTime && currentTime <= endTime) {
      camp.active(
        code,
        camp.productId,
        camp.timeToCheck,
        camp.timeEnd,
        camp.giftPrice,
        camp.minAmountCheck,
        camp.maxAmountCheck
      );
    }
  }

  const campaigns = [
    // new WalletAlert({
    //   code: 'NY25',
    //   link: "https://slimcase.vn/products/gia-do-dien-thoa-tu-tinh",
    //   title: `Thêm Giá Đỡ Điện Thoại Mag Safe Gấp Gọn`,
    //   sub_title: "tại đây",
    //   productId: "43927440097487",
    //   timeToCheck: "2025-01-01 00:00:00",
    //   timeEnd: "2025-01-05 23:59:59",
    //   giftPrice: 249000,
    //   minAmountCheck: 500000,
    //   maxAmountCheck: ''
    // })
  ];

  $("body").on("keyup", "#get_id_code", function () {
    const code = $(this).val();
    campaigns.forEach((camp) => applyCamp(camp, code));
  });
});
